import { render } from "./PlannelBody.vue?vue&type=template&id=aa18bb52&scoped=true"
import script from "./PlannelBody.vue?vue&type=script&lang=js"
export * from "./PlannelBody.vue?vue&type=script&lang=js"

import "./PlannelBody.vue?vue&type=style&index=0&id=aa18bb52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa18bb52"]])

export default __exports__